import Container from "MODULES/shared/containers/Container";

export default class ToggleSwitch extends Container {
  static defaultProps = {
    visible: false
  };

  state = {
    visible: this.props.visible
  };

  open = () => this.setState({ visible: true });
  close = () => this.setState({ visible: false });
  toggle = () => this.setState(state => ({ visible: !state.visible }));

  render() {
    return this.props.children(
      this.state.visible,
      this.open,
      this.close,
      this.toggle
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/ToggleSwitch.jsx